/**
 * Full-screen centered spinner used during session checks and lazy route loading.
 */
export function FullScreenLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );
}
